import { useState } from 'react';
import {
    ClockCircleOutlined,
    DollarOutlined,
    PercentageOutlined,
    InboxOutlined,
    RightOutlined,
    PushpinOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

type TabType = 'recent' | 'pinned';

interface JumpBackInItem {
    icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
    title: string;
    subtitle: string;
    path?: string;
}

const recentItems: JumpBackInItem[] = [
    {
        icon: DollarOutlined,
        title: 'Strategic Pricing',
        subtitle: 'Price Curve',
        path: '/pricing/recommendation/price-curve',
    },
    {
        icon: PercentageOutlined,
        title: 'Trade Promo Excellence',
        subtitle: 'Trade Promo Optimization',
        path: '/promo/analytics/tpo/plan',
    },
    {
        icon: InboxOutlined,
        title: 'Price Pack Architecture',
        subtitle: 'White Space Analysis',
        path: '/pricing/analytics/whitespace-analysis',
    },
];

const pinnedItems: JumpBackInItem[] = [
    {
        icon: PushpinOutlined,
        title: 'Growth Analysis',
        subtitle: '',
        path: 'promo/category-diagnostics/growth-analysis',
    },
    {
        icon: PushpinOutlined,
        title: 'Price Curve',
        subtitle: '',
        path: '/pricing/recommendation/price-curve',
    },
    {
        icon: PushpinOutlined,
        title: 'White Space Analysis',
        subtitle: '',
        path: '/pricing/analytics/whitespace-analysis',
    },
];

export default function JumpBackInCard() {
    const [activeTab, setActiveTab] = useState<TabType>('recent');
    const navigate = useNavigate();
    const currentItems = activeTab === 'recent' ? recentItems : pinnedItems;

    const handleItemClick = (item: JumpBackInItem) => {
        if (item.path) {
            console.log('Navigate to:', item.path);
            navigate(item.path);
        }
    };

    return (
        // <div className="h-full w-full bg-white rounded-2xl shadow-lg">
        <div className="">
            <div className="p-6">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className="h-8 w-[4px] rounded-full bg-violet-600" />
                        <div className="flex items-center justify-center gap-2">
                            <ClockCircleOutlined style={{ color: '#7c3aed', fontSize: 18 }} />
                            <h2 className="text-lg mb-0 font-semibold text-gray-900">Jump Back In</h2>
                        </div>
                    </div>

                    {/* Tabs */}
                    <div className="flex items-center gap-4">
                        <button
                            type="button"
                            onClick={() => setActiveTab('recent')}
                            className={`text-sm transition-colors ${
                                activeTab === 'recent'
                                    ? 'font-semibold text-gray-900'
                                    : 'font-normal text-gray-400 hover:text-gray-600'
                            }`}
                        >
                            Recent
                        </button>
                        <button
                            type="button"
                            onClick={() => setActiveTab('pinned')}
                            className={`text-sm transition-colors ${
                                activeTab === 'pinned'
                                    ? 'font-semibold text-gray-900'
                                    : 'font-normal text-gray-400 hover:text-gray-600'
                            }`}
                        >
                            Pinned
                        </button>
                    </div>
                </div>

                {/* Divider */}
                <div className="h-px bg-gray-200 mb-4" />

                {/* List Items */}
                <div className="space-y-3">
                    {currentItems.length > 0 ? (
                        currentItems.map((item, index) => {
                            const Icon = item.icon;
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    onClick={() => handleItemClick(item)}
                                    className="flex w-full items-center gap-4 rounded-xl p-4 text-left transition-all hover:bg-gray-50 border border-gray-100 hover:border-gray-200 hover:shadow-sm"
                                    style={{ backgroundColor: 'hsl(280 60% 97%)' }}
                                >
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white">
                                        <Icon className="text-xl text-gray-700" />
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <p className="font-semibold text-base text-gray-900 truncate">{item.title}</p>
                                        <p className="text-sm text-violet-600 truncate">{item.subtitle}</p>
                                    </div>

                                    <RightOutlined className="text-gray-400 text-sm" />
                                </button>
                            );
                        })
                    ) : (
                        <div className="flex items-center justify-center py-8 text-gray-400">
                            <p className="text-sm">No {activeTab} items</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export { JumpBackInCard };
